import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { COLORS } from 'shared/constants/COLORS';
const { PRIMARY_ICON } = COLORS;

function InvoiceIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10 0c5.527 0 10 4.473 10 10s-4.473 10-10 10S0 15.527 0 10 4.473 0 10 0zm0 1.395c-4.745 0-8.605 3.86-8.605 8.605 0 4.745 3.86 8.605 8.605 8.605 4.745 0 8.605-3.86 8.605-8.605 0-4.745-3.86-8.605-8.605-8.605zm0 6.94c.566 0 1.027.25 1.027.62v5.015c0 .316-.46.631-1.027.631-.592 0-1.013-.315-1.013-.631V8.955c0-.369.42-.62 1.013-.62zm0-3.093c.593 0 1.066.435 1.066.935s-.473.948-1.066.948c-.605 0-1.08-.448-1.08-.948 0-.5.475-.934 1.08-.934z"
        fill={props.htmlColor || PRIMARY_ICON}
        fillRule="nonzero"
        opacity="1"
      />
    </SvgIcon>
  );
}

export default InvoiceIcon;
